export enum PetAlertType {
    PetAlert = 1,
    MedicalAlert = 2
}
